import React from 'react';
import './Items.scss';
import Item from './Item';

function Items(props) {
  const {
    listing,
    orderData,
    history,
    orderData: { items },
    returnEligibilityItems,
    pendingOrderStatus,
    dataLocale,
  } = props;
  return (
    <div className="order-items">
      {items.map(item => {
        const returnEligibilityItemDetails = returnEligibilityItems
          ? returnEligibilityItems.find(rItem => rItem.id === item.id)
          : null;
        return (
          <Item
            key={item.id}
            dataLocale={dataLocale}
            history={history}
            item={item}
            listing={listing}
            orderData={orderData}
            pendingOrderStatus={pendingOrderStatus}
            returnEligibilityItemDetails={returnEligibilityItemDetails}
          />
        );
      })}
    </div>
  );
}

export default Items;
